import axios from "axios";
import { get_token } from "../../constant/urls/localStoarege";
import { serviceRequestAddCommentApiUrl, serviceRequestGetApiUrl } from "../../constant/urls/apiUrls";

export const getServiceRequestApi = async (data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${get_token()}`,
    },
  };

  const response = await axios.get(`${serviceRequestGetApiUrl.replace("http://", "https://")}${data ?? ""}`, config);

  return response;
};

export const addServiceRequestCommentApi = async (data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${get_token()}`,
    },
  };

  const response = await axios.post(serviceRequestAddCommentApiUrl, data, config);

  return response;
};